export default __webpack_public_path__ + "c62e14e0bb0a3f9dcba8e3dbf3d4485c.svg";